module.exports = __webpack_public_path__ + "img/modulo_Star.6bd68bb.svg";